import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterPeople = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-people-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterPeople.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterPeople.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterPeople.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterPeople;
